import Lookup from 'src/componentes/select2';

const TipoMudancaSolicitacaoGestaoMudancasRiscoLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoMudancaSolicitacaoGestaoMudancasRiscoLookup"
    clearable={false}
    {...rest}
  />
);

export default TipoMudancaSolicitacaoGestaoMudancasRiscoLookup;
